import { Copy } from 'lucide-react'
import { toast } from 'sonner'
import { cn } from '@/lib/utils'

type Props = {
  /** コピー対象のユーザーID（@なしの handle） */
  handle: string
  /** 指定すると「ラベル + 枠 + コピーボタン」のカード表示になる */
  label?: string
  className?: string
}

async function copyHandle(handle: string) {
  try {
    await navigator.clipboard.writeText(handle)
    toast.success('ユーザーIDをコピーしました')
  } catch {
    toast.error('コピーに失敗しました')
  }
}

export default function HandleCopy({ handle, label, className }: Props) {
  // label あり：検索画面などで「自分のID」を見せるカード表示
  if (label) {
    return (
      <div className={cn('flex flex-col gap-1', className)}>
        <span className="text-xs text-muted-foreground">{label}</span>
        <div className="flex items-center gap-2">
          <div className="flex-1 min-w-0 truncate rounded-md border bg-muted/40 px-3 py-2 text-sm font-mono">
            @{handle}
          </div>
          <button
            type="button"
            onClick={() => copyHandle(handle)}
            className="flex items-center gap-1 min-h-[44px] shrink-0 rounded-md border px-3 text-sm text-muted-foreground hover:text-foreground"
            aria-label="ユーザーIDをコピー"
          >
            <Copy size={16} />
            コピー
          </button>
        </div>
      </div>
    )
  }

  // label なし：プロフィールの @handle 表示をそのままコピーボタン化
  return (
    <button
      type="button"
      onClick={() => copyHandle(handle)}
      className={cn(
        'inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground',
        className,
      )}
      aria-label="ユーザーIDをコピー"
    >
      @{handle}
      <Copy size={14} />
    </button>
  )
}
